import CreatePortfolioModal from './CreatePortfolioModal';

export default CreatePortfolioModal;
